import Cookies from 'js-cookie';

const COOKIE_NEWSLETTER_SHOWN = 'newsletter-shown';
const CLASS_NAME_FADE = 'fade';
const CLASS_NAME_SHOW = 'show';
const CLASS_NAME_OPEN = 'modal-open';
const CLASS_BACK_DROP = 'modal-backdrop';

// const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="modal"]';
// const SELECTOR_DATA_DISMISS = '[data-bs-dismiss="modal"]';

class Modal {
  constructor() {
    this.init();
  }

  init() {
    const modalTogglebuttons = document.querySelectorAll('.js-modal-toggle');
    const modalClosebuttons = document.querySelectorAll('.js-btn-modal-close');

    modalTogglebuttons &&
      modalTogglebuttons.forEach(modalTogglebutton => {
        modalTogglebutton.addEventListener('click', element => {
          const targettModalId = element.currentTarget.dataset.modalTargetId;
          this.showModal(targettModalId);
        });
      });

    modalClosebuttons &&
      modalClosebuttons.forEach(modalClosebutton => {
        modalClosebutton.addEventListener('click', element => {
          const currentModal = element.currentTarget.closest('.js-sp-modal');
          const currentModalId = currentModal.id;
          this.hideModal(currentModalId);
        });
      });

    // News letter modal only on first load

    // let newTime = setTimeout(console.log('setTimeout'), 50000);

    if (!Cookies.get(COOKIE_NEWSLETTER_SHOWN) && !this.isNewsletterPage()) {
      this.showModal('modal-newsletter');
    }

    document
      .querySelector('#modal-newsletter .js-btn-modal-close')
      ?.addEventListener('click', () => {
        Cookies.set(COOKIE_NEWSLETTER_SHOWN, true);
      });

    let isProductPage = document.body.classList.contains('template-product');

    if (isProductPage && window.location.href.indexOf('contact_posted=true') > -1) {
      this.showModal('modal-product-enquire');
    }
  }

  isNewsletterPage() {
    return window.location.pathname.includes('pages/newsletter-signup');
  }

  showBackdrop() {
    const _backdrop = document.createElement('div');
    _backdrop.className = CLASS_BACK_DROP;
    _backdrop.classList.add(CLASS_NAME_FADE);

    document.body.classList.add(CLASS_NAME_OPEN);
    document.body.appendChild(_backdrop);

    setTimeout(() => {
      _backdrop.classList.add(CLASS_NAME_SHOW);
    }, 20);
  }

  removeBackdrop() {
    // const hasModalOpen = document.body.classList.contains(CLASS_NAME_OPEN);

    document.body.removeChild(document.querySelector('.modal-backdrop'));
    document.body.classList.remove(CLASS_NAME_OPEN);
  }

  showModal(id) {
    const modal = document.getElementById(id);
    if (modal) {
      this.showBackdrop();
      modal.style.display = 'block';
      setTimeout(() => {
        modal.classList.add(CLASS_NAME_SHOW);
      }, 10);
    }
  }

  hideModal(id) {
    const modal = document.getElementById(id);

    modal.classList.remove(CLASS_NAME_SHOW);
    setTimeout(() => {
      modal.style.display = 'none';
    }, 100);

    if (id === 'modal-video') {
      const videoElement = document.getElementById('videoTag');
      videoElement.pause();
    }

    this.removeBackdrop();
  }
}

export default new Modal();
